import { Dispatch, EventHandler } from 'react';
import { IStatePopup, IUsePopupState } from './usePopupState';
export const initialState = {
  visibleId: '',
  supportingHTMLElement: null
};
const eventOptions = {
  bubbles: true,
  cancelable: false,
  composed: true
};
export function createPopupState({
  isTooltip,
  supportingHTMLElement,
  toggleState,
  triggers,
  visibleId
}) {
  const handleOpen = e => {
    const value = e.target && e.target.getAttribute(`data-${isTooltip ? 'tooltip' : 'popup'}-value`);
    if (!value || typeof window === 'undefined') {
      return;
    }
    toggleState({
      visibleId: value.replace('toggler-', ''),
      supportingHTMLElement: e.target
    });
    e.target.dispatchEvent(new CustomEvent('eapteka-ui:popupopen', eventOptions));
  };
  const handleClose = e => {
    if (typeof window === 'undefined') {
      return;
    }
    toggleState(undefined);
    e.target.dispatchEvent(new CustomEvent('eapteka-ui:popupclose', eventOptions));
  };
  const handleToggle = e => {
    if (visibleId) handleClose(e);else handleOpen(e);
  };
  const eventAttributes = {};
  if (triggers.includes('click')) {
    eventAttributes.onPointerDown = handleToggle;
  }
  if (triggers.includes('hover')) {
    eventAttributes.onPointerEnter = handleOpen;
    eventAttributes.onPointerLeave = handleClose;
  }
  if (triggers.includes('focus')) {
    eventAttributes.onFocus = handleOpen;
  }
  return {
    eventAttributes,
    isTooltip,
    onClose: handleClose,
    onOpen: handleOpen,
    onToggle: handleToggle,
    supportingHTMLElement,
    triggers,
    visibleId
  };
}
export const bindSupportingElement = (id, {
  visibleId,
  eventAttributes,
  isTooltip
}) => ({
  ...eventAttributes,
  'aria-haspopup': true,
  'aria-describedby': visibleId === id ? id : null,
  [`data-${isTooltip ? 'tooltip' : 'popup'}-value`]: `toggler-${id}`
});